import {Button, Modal} from "react-bootstrap";
import React, {useState} from 'react';
import {components} from "react-select";
import Select from 'react-select'
import moment from "moment/moment";
import {RiArrowDownSFill} from "react-icons/ri";

export default function ValuesFilterModal(props) {
    const options = [
        {value: '>', label: 'Greater Than (>)'},
        {value: '<', label: 'Less Than (<)'},
        {value: '>=', label: 'Greater Than or Equal to (>=)'},
        {value: '<=', label: 'Less Than or Equal to (<=)'},
        {value: '=', label: 'Equal (=)'},
    ]
    const [isLeakFlowRateSwitchOn, setIsLeakFlowRateSwitchOn] = useState(false);
    const [isLeakDurationSwitchOn, setIsLeakDurationSwitchOn] = useState(false);
    const [isLeakVolumeSwitchOn, setIsLeakVolumeSwitchOn] = useState(false);
    const [leakFlowRateComparisonSign, setLeakFlowRateComparisonSign] = useState(options[3]);
    const [leakDurationComparisonSign, setLeakDurationComparisonSign] = useState(options[3]);
    const [leakVolumeComparisonSign, setLeakVolumeComparisonSign] = useState(options[3]);
    const [leakFlowRateInputValue, setLeakFlowRateInputValue] = useState('');
    const [leakDurationInputValue, setLeakDurationInputValue] = useState('');
    const [leakVolumeInputValue, setLeakVolumeInputValue] = useState('');
    const LEAK_FLOW_RATE_FIELD = 'leakFlowRate';
    const READABLE_ACTUAL_DURATION_FIELD = 'readableActualDuration';
    const ACTUAL_LEAK_VOLUME_FIELD = 'actualLeakVolume';

    const DropdownIndicator = props => {
        return (components.DropdownIndicator && (<components.DropdownIndicator {...props}>
            <RiArrowDownSFill color={'black'} size={20}/>
        </components.DropdownIndicator>));
    };

    const checkLeakDurationInputValue = () => {
        let finalInputValue = '';
        if (leakDurationInputValue.length === 0) {
            return;
        } else if (leakDurationInputValue.length === 1 && !(leakDurationInputValue.includes(':'))) {
            finalInputValue = '0' + leakDurationInputValue + ':00';
        } else if (leakDurationInputValue.length === 2) {
            finalInputValue = leakDurationInputValue + ':00';
        } else if (leakDurationInputValue.length === 3 && leakDurationInputValue.includes(':') && leakDurationInputValue[2] === ':') {
            finalInputValue = leakDurationInputValue + '00'
        } else if (leakDurationInputValue.length === 3 && !(leakDurationInputValue.includes(':'))) {
            finalInputValue = leakDurationInputValue.slice(0, 2) + ':0' + leakDurationInputValue.slice(2);
        } else if (leakDurationInputValue.length === 4 && !(leakDurationInputValue.includes(':'))) {
            finalInputValue = leakDurationInputValue.slice(0, 2) + ':' + leakDurationInputValue.slice(2);
        } else if (leakDurationInputValue.length === 4 && leakDurationInputValue.includes(':') && leakDurationInputValue[2] === ':') {
            finalInputValue = leakDurationInputValue.slice(0, 3) + '0' + leakDurationInputValue.slice(3);
        } else {
            finalInputValue = leakDurationInputValue;
        }
        if (/^([0-9]?[0-9]|2[0-3]):[0-9][0-9]$/.test(finalInputValue)) {
            setLeakDurationInputValue(finalInputValue);
        } else {
            setLeakDurationInputValue('00:00');
        }
    }

    const handleDuplicates = (filteredData) => {
        return filteredData.filter((value, index, self) => index === self.findIndex((t) => (t.id === value.id)));
    }

    const filterAllData = () => {
        let filteredData = [];
        if (isLeakFlowRateSwitchOn) {
            filteredData = filteredData.concat(filterByValues(leakFlowRateComparisonSign.value, leakFlowRateInputValue, LEAK_FLOW_RATE_FIELD));
        }
        if (isLeakDurationSwitchOn) {
            filteredData = filteredData.concat(filterByValues(leakDurationComparisonSign.value, leakDurationInputValue, READABLE_ACTUAL_DURATION_FIELD));
        }
        if (isLeakVolumeSwitchOn) {
            filteredData = filteredData.concat(filterByValues(leakVolumeComparisonSign.value, leakVolumeInputValue, ACTUAL_LEAK_VOLUME_FIELD));
        }
        finalizeFiltering(filteredData);
        props.setAlertTableData(handleDuplicates(filteredData));
    }

    const finalizeFiltering = (filteredData) => {
        let existingFilteredData = props.tableFilteredData;
        if (existingFilteredData.length > 0) {
            let newFilteredData = [];
            filteredData.forEach(filteredDataObj => {
                let index = existingFilteredData.findIndex(existingFilteredDataObj => existingFilteredDataObj.id === filteredDataObj.id);
                if (index !== -1) {
                    newFilteredData.push(existingFilteredData[index]);
                }
            })
            filteredData = newFilteredData;
        }
        props.handleTableColumnFilter(handleDuplicates(filteredData));
    }

    const getField = (field, obj) => {
        switch (field) {
            case 'leakFlowRate':
                return obj.leakFlowRate;
            case 'readableActualDuration':
                return obj.readableActualDuration;
            case 'actualLeakVolume':
                return obj.actualLeakVolume;
            default:
                return obj.leakFlowRate;
        }
    }

    const convertHmFormatToSeconds = (input) => {
        let str = input + ":00";
        let p = str.split(':'),
            s = 0, m = 1;

        while (p.length > 0) {
            s += m * parseInt(p.pop(), 10);
            m *= 60;
        }
        return s;
    }

    const convertSecondsToHm = (input) => {
        const secs = input;
        const formatted = moment.utc(secs * 1000).format("HH:mm");
        return formatted;
    }

    const filterByValues = (comparisonSign, inputValue, field) => {
        let filteredData;
        const value = field === READABLE_ACTUAL_DURATION_FIELD ? convertHmFormatToSeconds(inputValue) : inputValue;
        filteredData = props.data.filter(obj => {
            switch (comparisonSign) {
                case '>':
                    if (getField(field, obj) > value) {
                        return obj;
                    }
                    break;
                case '<':
                    if (getField(field, obj) < value) {
                        return obj;
                    }
                    break;
                case '>=':
                    if (getField(field, obj) >= value) {
                        return obj;
                    }
                    break;
                case '<=':
                    if (getField(field, obj) <= value) {
                        return obj;
                    }
                    break;
                case '=': {
                    if (field === 'readableActualDuration' && convertSecondsToHm(getField(field, obj)) === inputValue) {
                        return obj;
                    } else if (getField(field, obj) == value) {
                        return obj;
                    }
                }
                    break;
            }
        })
        return filteredData
    }

    const onInputChange = (e, setInput) => {
        let isDurationInput = false;
        let re = /^[0-9\b]+$/;
        if (setInput === setLeakDurationInputValue) {
            isDurationInput = true;
            re = /^[0-9\b\:]+$/;
        }
        if (isDurationInput && e.target.value.length > 5) {
            return;
        }
        if (e.target.value === '' || re.test(e.target.value)) {
            if (isDurationInput && e.target.value.length === 2 && !(leakDurationInputValue.includes(':'))) {
                setInput(e.target.value + ':');
            } else {
                setInput(e.target.value);
            }
        }
    }

    const onResetFilters = () => {
        setLeakVolumeInputValue('');
        setLeakFlowRateInputValue('');
        setLeakDurationInputValue('');
        setIsLeakFlowRateSwitchOn(false);
        setIsLeakVolumeSwitchOn(false);
        setIsLeakDurationSwitchOn(false);
        setLeakFlowRateComparisonSign(options[3]);
        setLeakDurationComparisonSign(options[3]);
        setLeakVolumeComparisonSign(options[3]);
        props.setAlertTableData(props.data);
        finalizeFiltering(props.data);
    }

    return (
        <Modal dialogClassName="filter-modal" show={props.show} onHide={() => props.setShow(false)} style={{marginTop: '10%', left: '-20%'}}>
            <Modal.Header closeButton>
                <Modal.Title>Filter Displayed Leaks</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <table>
                    <tbody>
                    <tr>
                        <td style={{width: '24%'}}>
                            <div className="custom-control custom-switch">
                                <input checked={isLeakFlowRateSwitchOn} onChange={() => setIsLeakFlowRateSwitchOn(!isLeakFlowRateSwitchOn)} type="checkbox" className="custom-control-input" id="customSwitch1"/>
                                <label className="custom-control-label" htmlFor="customSwitch1">Flow Rate (L/h)</label>
                            </div>
                        </td>
                        <td style={{width: '41%'}}>
                            <Select value={leakFlowRateComparisonSign} onChange={(e) => setLeakFlowRateComparisonSign(e)} options={options} components={{IndicatorSeparator: () => null, DropdownIndicator}}/>
                        </td>
                        <td style={{width: '20%'}}>
                            <input value={leakFlowRateInputValue} onChange={(e) => onInputChange(e, setLeakFlowRateInputValue)} style={{width: '100%'}}/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className="custom-control custom-switch">
                                <input checked={isLeakDurationSwitchOn} onChange={() => setIsLeakDurationSwitchOn(!isLeakDurationSwitchOn)} type="checkbox" className="custom-control-input" id="customSwitch2"/>
                                <label className="custom-control-label" htmlFor="customSwitch2">Duration (hh:mm)</label>
                            </div>
                        </td>
                        <td>
                            <Select value={leakDurationComparisonSign} onChange={(e) => setLeakDurationComparisonSign(e)} options={options} components={{IndicatorSeparator: () => null, DropdownIndicator}}/>
                        </td>
                        <td>
                            <input onBlur={checkLeakDurationInputValue} value={leakDurationInputValue} onChange={(e) => onInputChange(e, setLeakDurationInputValue)} style={{width: '100%'}}/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className="custom-control custom-switch">
                                <input checked={isLeakVolumeSwitchOn} onChange={() => setIsLeakVolumeSwitchOn(!isLeakVolumeSwitchOn)} type="checkbox" className="custom-control-input" id="customSwitch3"/>
                                <label className="custom-control-label" htmlFor="customSwitch3">Volume (L)</label>
                            </div>
                        </td>
                        <td>
                            <Select value={leakVolumeComparisonSign} onChange={(e) => setLeakVolumeComparisonSign(e)} options={options} components={{IndicatorSeparator: () => null, DropdownIndicator}}/>
                        </td>
                        <td>
                            <input value={leakVolumeInputValue} onChange={(e) => onInputChange(e, setLeakVolumeInputValue)} style={{width: '100%'}}/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => filterAllData()}>Set</Button>
                <Button variant="primary" onClick={() => onResetFilters()}>Clear</Button>
                <Button variant="secondary" onClick={() => props.setShow(false)}>Close</Button>
            </Modal.Footer>
        </Modal>
    )
}
